module.exports = __webpack_public_path__ + "static/media/1 21 gatt.2d319a37.mp3";